module.exports = __webpack_public_path__ + "assets/img/media_4.45f802ee.png";